export const CONTACT = {
  phone: "98253 95666",
  phoneHref: "tel:+919825395666",
  emailPrimary: "jignesh@ashutoshgroup.co.in",
  emailGeneral: "info@ashutoshgroup.co.in",
  address: "A-909 & 911, Atma House, Opp. Old RBI, Ashram Road, Ahmedabad, Gujarat",
  legalName: "Ashutosh Capital Advisory Private Limited",
  cin: "U67190GJ1995PTC028400",
};

export const PROFILE_PDF = "/Ashutosh-Capital-Profile.pdf";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1565043534426-8a67ac8671e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  legacy: "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  ashutoshLogo: "/assets/ashutosh_logo.jpg",
  cubenzLogo: "/assets/cubenz_logo.jpg",
  cubenzCharging: "/assets/cubenz_charging.jpg",
  heroGreen: "/assets/hero_green.jpg",
  rebolt: "/assets/rebolt.png",
  hmel: "/assets/hmel.jpg",
  solarBess: "/assets/solar_bess.jpg",
  evCars: "/assets/ev_cars.jpg",
  busEka: "/assets/bus_eka.jpg",
  ketoBus: "/assets/keto_ke9.png",
  ketoFront: "/assets/keto_front.png",
  cubenz1: "/assets/cubenz_1.jpg",
  cubenz2: "/assets/cubenz_2.jpg",
  cubenz3: "/assets/cubenz_3.jpg",
  evFleet: "/assets/bus_fleet.webp",
  leaders: {
    jayantilal: "/assets/leader_jayantilal.jpg",
    dhaval: "/assets/leader_dhaval.jpg",
    jignesh: "/assets/leader_jignesh.jpg",
    sudipta: "/assets/Sudipta.png",
  },
};

export const HERO_STATS = [
  { v: "43+", l: "Years of experience" },
  { v: "₹190 Cr", l: "Green mobility commitment" },
  { v: "₹1,000 Cr", l: "AUM ambition · Mar 2028" },
];

export const CREDENTIALS = [
  { value: "43+", label: "Years of financial-services experience" },
  { value: "1983", label: "Registered as an RBI NBFC" },
  { value: "₹250 Cr", label: "NPA receivables pool acquired" },
  { value: "₹400 Cr", label: "Tata Motors Finance NPA pool" },
  { value: "₹268 Cr", label: "LSA pool coordinated" },
  { value: "₹100 Cr+", label: "Revenue / activity reference" },
  { value: "₹1,000 Cr+", label: "GIFT City funding exposure" },
  { value: "₹190 Cr", label: "Green Mobility architecture" },
];

export const HERITAGE = [
  { year: "1983", title: "The Foundation", desc: "Established Ashutosh Lease Financing Ltd., a registered RBI NBFC." },
  { year: "2002–03", title: "Hire-Purchase & Recovery", desc: "GE Countrywide hire-purchase contract and NPA recovery experience." },
  { year: "2009", title: "₹250 Cr ICICI Pool", desc: "₹250 Cr receivables NPA pool acquired from ICICI Bank Ltd. via Invent Assets Securitization & Reconstruction — recoverable amount ₹750 Cr." },
  { year: "2020", title: "₹668 Cr Coordinated", desc: "₹400 Cr Tata Motors Finance NPA pool + ₹268 Cr LSA pool coordinated for Gujarat — recoverable amount ₹850 Cr." },
];

export const HERITAGE_CAPABILITIES = ["Credit judgement", "Asset understanding", "Transaction execution", "Documentation", "Collections", "Risk", "Capital relationships"];

export const FOCUS_AREAS = [
  { key: "buses", title: "Electric Buses", desc: "Vehicle acquisition and fleet expansion — the anchor of India's public-transport shift.", image: IMAGES.busEka, tag: "₹400 Cr · 40% of target" },
  { key: "charging", title: "Charging", desc: "DC fast charging, depot power and the electrical backbone that keeps fleets moving.", image: IMAGES.cubenzCharging, tag: "₹250 Cr · 25%" },
  { key: "cpo", title: "CPOs", desc: "Charging-network expansion and the operating assets behind every plugged-in kilometre.", image: IMAGES.rebolt, tag: "₹100 Cr · 10%" },
  { key: "commercial", title: "Commercial EVs", desc: "Asset finance and growth capital for the fleets carrying India's freight and people.", image: IMAGES.evCars, tag: "₹200 Cr · 20%" },
  { key: "energy", title: "Energy", desc: "Solar, storage and battery infrastructure that powers a cleaner grid.", image: IMAGES.solarBess, tag: "₹50 Cr · 5%" },
];

export const ARCHITECTURE = [
  { id: "01", name: "KETO Motors", amount: "₹100 Cr", category: "EV Bus Financing", desc: "Anchor financing for the Urbanova KE9 — a 9-metre, 32-seat electric city bus with 150 km range, deployed across scaling urban corridors.", image: IMAGES.ketoBus },
  { id: "02", name: "Cubenz Power", amount: "₹50 Cr", category: "Charging Infrastructure", desc: "Capital for DC fast-charging depots and the electrical infrastructure required to deploy mobility at scale — 3 kW to 360 kW, Make-in-India hardware.", image: IMAGES.cubenzCharging },
  { id: "03", name: "CPO Ecosystem", amount: "₹40 Cr", category: "Charging Point Operators", desc: "₹10 Cr each across four Charging Point Operators — a distributed, de-risked charging-network play spanning vehicles, infrastructure and operations.", image: IMAGES.rebolt },
];

export const ENGINE_CHAIN = ["Capital", "Vehicles", "Charging", "Operators", "Utilisation", "Cash Flow", "Scale"];

export const ENGINE_PARTNERS = [
  { name: "KETO Motors", role: "Electric buses", note: "Urbanova KE9 · 9m city bus" },
  { name: "Cubenz Power", role: "Charging infrastructure", note: "Power Reimagined", logo: IMAGES.cubenzLogo },
  { name: "CPO Partners", role: "Deployment & operations", note: "4 operators · networked" },
];

export const OPERATING_STEPS = [
  { id: "01", title: "Originate", desc: "OEMs • fleets • CPOs • charging • developers" },
  { id: "02", title: "Underwrite", desc: "Promoter • asset • cash flow • risk" },
  { id: "03", title: "Structure", desc: "Asset • fleet • project • working capital • structured" },
  { id: "04", title: "Deploy", desc: "Controlled financing programmes" },
  { id: "05", title: "Monitor", desc: "Collections • utilisation • asset performance" },
  { id: "06", title: "Scale", desc: "Recycle capital • institutional partnerships" },
];

export const ASSET_TO_CAPITAL = [
  { layer: "Green Asset", desc: "EV bus • commercial EV • charger • CPO • energy" },
  { layer: "Operating Economics", desc: "Utilisation • revenue • energy cost • maintenance • uptime" },
  { layer: "Credit", desc: "Promoter • asset • cash flow • collateral • risk" },
  { layer: "Capital", desc: "Ashutosh • banks • NBFCs • institutional / strategic capital" },
  { layer: "Portfolio", desc: "AUM • performance • concentration • risk • capital recycling" },
];

export const GREEN_CREDIT = [
  { title: "Promoter", desc: "Track record • governance • financial strength" },
  { title: "Asset", desc: "Technology • useful life • collateral • residual value" },
  { title: "Operations", desc: "Utilisation • routes • revenue • operating costs" },
  { title: "Cash Flow", desc: "Visibility • repayment capacity • coverage • stress" },
  { title: "Energy", desc: "Charging availability • energy cost • dependency" },
  { title: "Asset Data", desc: "Utilisation • maintenance • downtime • asset health" },
];

export const ASSET_RISK_INTEL = [
  { title: "Telemetry & Utilisation", desc: "Vehicle / asset usage, uptime, productivity" },
  { title: "Battery & Asset Health", desc: "Asset condition and residual value" },
  { title: "Portfolio Monitoring", desc: "Collections, utilisation, cash flow, performance" },
  { title: "Early-Risk Detection", desc: "Signals for timely intervention" },
  { title: "Lifecycle Management", desc: "Refinancing, redeployment, recovery" },
];

export const ROADMAP = [
  { label: "EV Buses / Fleets", amount: "₹400 Cr", pct: 40 },
  { label: "Charging Infrastructure", amount: "₹250 Cr", pct: 25 },
  { label: "Commercial EV Asset Finance", amount: "₹200 Cr", pct: 20 },
  { label: "CPO / Network Finance", amount: "₹100 Cr", pct: 10 },
  { label: "Energy / Green Assets", amount: "₹50 Cr", pct: 5 },
];

export const PHASES = [
  { id: "01", phase: "Build", period: "Q3–Q4 FY26–27", desc: "Credit policy • underwriting • risk matrix • legal docs • capital partners • dedicated team." },
  { id: "02", phase: "Deploy", period: "FY2027", desc: "Convert ₹190 Cr commitments • EV bus & charging corridors • commercial EV fleet finance." },
  { id: "03", phase: "Scale", period: "H1 FY27–28", desc: "Institutional funding • replicate programmes • structured / portfolio finance • CPO + energy." },
  { id: "04", phase: "₹1,000 Cr AUM", period: "March 2028 · or earlier", desc: "A diversified Green Finance book — scaled subject to credit quality, capital availability and regulatory readiness." },
];

export const CAPITAL_STRATEGY = [
  { title: "Banks & NBFCs", desc: "Co-lending • term facilities • refinance • structured funding" },
  { title: "Institutional / Climate", desc: "Climate lenders • impact capital • green asset exposure" },
  { title: "Strategic Capital", desc: "Family offices • strategic investors • sector-aligned capital" },
  { title: "Portfolio Recycling", desc: "Repayments • refinancing • portfolio turnover" },
];

export const LEADERSHIP = [
  {
    name: "Jayantilal Patel",
    photo: IMAGES.leaders.jayantilal,
    role: "Promoter & Managing Director",
    meta: "Aged 72 · 43+ years",
    points: ["Ashutosh Lease Financing, NBFC", "Ashutosh Finsec, NBFC", "Ashutosh Autofin Pvt. Ltd., NBFC", "Ashutosh Management Services LLP"],
  },
  {
    name: "Dhaval J. Patel",
    photo: IMAGES.leaders.dhaval,
    role: "Director",
    meta: "Operations & Execution",
    points: ["Operations", "Strategic support", "Compliance", "Execution"],
  },
  {
    name: "Jignesh Anand",
    photo: IMAGES.leaders.jignesh,
    role: "Executive Director",
    meta: "IIM Indore · 30+ years",
    points: ["₹150 Cr+ revenue built", "1,000+ distributors · 100+ offices", "20%+ YoY growth", "MSc • PGDBM • MDP"],
  },
  {
    name: "Sudipta Bhattacharya",
    photo: IMAGES.leaders.sudipta,
    role: "Marketing Head",
    meta: "",
    points: [],
  },
];

export const CERTIFICATES = [
  { entity: "Ashutosh Autofin Pvt. Ltd.", reg: "B.01.00404", date: "March 2002", note: "Formerly Citizen Eco-Capital Ltd." },
  { entity: "Ashutosh Finsec Limited", reg: "B.01.00399", date: "March 2002", note: "RBI Ahmedabad Regional Office" },
  { entity: "Ashutosh Lease Financing Ltd.", reg: "B.01.00331", date: "Since 2000", note: "Original NBFC registration" },
];

export const INTERESTS = [
  "EV Bus / Fleet Financing",
  "Charging Infrastructure",
  "Commercial EV Asset Finance",
  "CPO / Network Finance",
  "Institutional / Co-lending",
  "General Enquiry",
];

export const NAV_LINKS = [
  { label: "Legacy", to: "/legacy" },
  { label: "Green Finance", to: "/green-finance" },
  { label: "Operating Model", to: "/operating-model" },
  { label: "Roadmap", to: "/roadmap" },
  { label: "Leadership", to: "/leadership" },
  { label: "Certifications", to: "/certifications" },
];
